import { Palette } from '@/themes/themeOverrides/Palette';

export const MuiDialogStyles = {
    styleOverrides: {
        root: {
            '& .MuiBackdrop-root.MuiModal-backdrop': {
                backgroundColor: 'rgba(255, 255, 255, 0.85) !important',
            },
        },
        container: {
            '& .MuiPaper-elevation': {
                boxShadow: Palette.boxShadow.elevation16,
            },
        },
    },
};
